import React from 'react';
import { Spinner } from './Spinner';

interface PageLoadingProps {
  message?: string;
}

export const PageLoading: React.FC<PageLoadingProps> = ({ message = 'Yükleniyor...' }) => (
  <div className="flex items-center justify-center p-12 text-gray-500">
    <Spinner size="lg" className="mr-3 text-blue-500" />
    <span className="text-lg">{message}</span>
  </div>
);
